import React, { useEffect, useRef, useState } from 'react';
import { LandingTemplatesSection } from '@modules/Landing/Components/DesktopLanding/LandingTemplatesSection/LandingTemplatesSection';
import { LandingHousePlansSection } from '@modules/Landing/Components/DesktopLanding/LandingHousePlansSection/LandingHousePlansSection';
import css from './TemplatesTypesSection.module.css';
import classNames from 'classnames';

interface TemplateType {
    header: string;
    content: React.ComponentType;
}

const TemplateTypes: TemplateType[] = [
    {
        header: 'Templates',
        content: LandingTemplatesSection,
    },
    // {
    //     header: 'House plans',
    //     content: LandingHousePlansSection,
    // },
];

export const TemplatesTypesSection: React.FC = () => {
    const [activeType, setActiveType] = useState<TemplateType>(
        TemplateTypes[0]
    );
    const handleSetActiveTemplateType = (typeIndex: number) => {
        setActiveType(TemplateTypes[typeIndex]);
    };
    const [markerStyle, setMarkerStyle] = useState<{
        left: number;
    }>({ left: 0 });
    const headersRef = useRef<HTMLDivElement>(null);
    const titleRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        const updateMarker = () => {
            const activeIndex = TemplateTypes.findIndex(
                type => type.header === activeType.header
            );
            const activeTitle = titleRefs.current[activeIndex];
            if (activeTitle && headersRef.current) {
                const { offsetLeft } = activeTitle;
                setMarkerStyle({
                    left: offsetLeft,
                });
            }
        };

        updateMarker();
        window.addEventListener('resize', updateMarker);
        return () => window.removeEventListener('resize', updateMarker);
    }, [activeType]);

    return (
        <section className={css.section}>
            <div className={css.headers} ref={headersRef}>
                {TemplateTypes.map((type, index) => (
                    <div
                        className={classNames(css.title, {
                            [css.activeTitle]:
                                activeType.header === type.header,
                        })}
                        onClick={() => {
                            handleSetActiveTemplateType(index);
                        }}
                        ref={el => (titleRefs.current[index] = el)}
                    >
                        {type.header}
                    </div>
                ))}
                <div
                    className={css.marker}
                    style={{
                        // width: `${markerStyle.width}px`,
                        left: `${markerStyle.left}px`,
                    }}
                />
            </div>
            <div>{React.createElement(activeType.content)}</div>
        </section>
    );
};
